<template>
  <span class="tree-expand">
    <span v-show="DATA.isEdit" class="tree-label">
      <el-input
        :ref="'treeInput' + DATA.id"
        v-model="DATA.label"
        class="edit"
        size="mini"
        autofocus
        @click.stop.native="nodeEditFocus"
        @blur="nodeEditPass(STORE, DATA, NODE)"
        @keyup.enter.native="nodeEditPass(STORE, DATA, NODE)"
      ></el-input>
    </span>
    <span v-show="!DATA.isEdit">
      <span>{{ DATA.label }} </span>
    </span>
    <span v-show="!DATA.isEdit" class="tree-btn">
      <i class="el-icon-plus" @click.stop="nodeAdd(STORE, DATA, NODE)"></i>
      <i class="el-icon-edit" @click.stop="nodeEdit(STORE, DATA, NODE)"></i>
      <i class="el-icon-delete" @click.stop="nodeDel(STORE, DATA, NODE)"></i>
    </span>
  </span>
</template>

<script>
import Vue from "vue";
export default {
  props: ["NODE", "DATA", "STORE", "maxexpandId"],
  data() {
    return {
      isEdit: true,
    };
  },
  methods: {
    nodeAdd(s, d, n) {
      //新增
      this.$emit("nodeAdd", s, d, n);
    },
    nodeEdit(s, d, n) {
      //编辑
      d.isEdit = true;
      this.$nextTick(() => {
        this.$refs["treeInput" + d.id].$refs.input.focus();
      });
      this.$emit("nodeEdit", s, d, n);
    },
    nodeDel(s, d, n) {
      //删除
      this.$emit("nodeDel", s, d, n);
    },
    nodeEditPass(s, d, n) {
      if (d.isEdit === false) {
        return;
      }
      // 提交通过
      d.isEdit = false;
      //删除
      this.$emit("nodeEditPass", s, d, n);
    },
    handleNodeClick(d, n, s) {
      //点击节点
      d.isEdit = false; //放弃编辑状态
    },
    nodeEditFocus() {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/TreeRender.vue